export default __webpack_public_path__ + "static/media/visual-data.e1f90ca1.svg";